package com.essntl.features.currency.ui.addcurrency

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.settings.domain.model.configuration.ConfigurationCurrencyModel
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.currency.domain.model.CurrencyModel

data class AddCurrencyState(
    val getAllCurrencies: State<List<CurrencyModel>> = State(),
    val selectedCurrenciesCode: List<String> = emptyList(),

    val configurationCurrency: MutableState<ConfigurationCurrencyModel?> = mutableStateOf(null),
    val addCurrency: State<ConfigurationCurrencyModel> = State(),
)
